import { t } from "../../i18n/dict";
import { langFromPath } from "../../i18n/lang";
import { Page } from "../../layout/Page";
import { Button } from "../../ui/Button";
import { Section } from "../../ui/Section";

interface Suggestion {
  label: string;
  href: string;
}

interface ComingSoonPageProps {
  title: string;
  suggestions: readonly Suggestion[];
}

/**
 * Shared honest placeholder for sections the old site rendered as a bare
 * "Coming Soon" banner (Scientific Research, Prayers & Music). Says what's
 * actually true - this section isn't built yet - and points visitors at
 * what already is, instead of a dead end.
 */
export function ComingSoonPage({ title, suggestions }: ComingSoonPageProps) {
  const { lang } = langFromPath(window.location.pathname);

  return (
    <Page title={title} heading={title}>
      <Section lede={t(lang, "sectionComingSoonLede")}>
        <div className="flex flex-wrap gap-3">
          {suggestions.map((s) => (
            <Button key={s.href} href={s.href} variant="secondary">
              {s.label}
            </Button>
          ))}
        </div>
      </Section>
    </Page>
  );
}
